import { 
  Component, 
  OnInit,
  OnChanges,
  OnDestroy,
  Input,
  SimpleChanges,
  Output,
  EventEmitter,
  ViewChild,
  Inject,
  forwardRef
} from '@angular/core';

import { 
  FormGroup,
  Validators 
} from '@angular/forms';

import { MatLegacySelectChange as MatSelectChange } from '@angular/material/legacy-select';
import { isEqual, isNil, isEmpty } from 'lodash-es';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { DatexFormControl } from './models/datex-form-control';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  SeparatorModel,
  ButtonStyles 
} from './models/control';
import { Styles, ControlContainerStyles } from './models/style';
import { FieldModel } from './models/field';
import { ToolModel } from './models/tool';
import { TabItemModel, TabGroupModel } from './models/tab';
import { WidgetModel } from './models/widget';
import { FieldsetModel } from './models/fieldset';
import { BaseComponent } from './components/base.component';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { FootprintManager_ShellService } from './FootprintManager.shell.service';
import { FootprintManager_OperationService } from './FootprintManager.operation.service';
import { FootprintManager_DatasourceService } from './FootprintManager.datasource.index';
import { FootprintManager_FlowService } from './FootprintManager.flow.index';
import { FootprintManager_ReportService } from './FootprintManager.report.index';
import { FootprintManager_LocalizationService } from './FootprintManager.localization.service';
import { FootprintManager_configurations_storage_categories_hub_ComponentContextService } from './FootprintManager.configurations_storage_categories_hub.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './FootprintManager.frontend.types'
import { $frontendTypes as $types} from './FootprintManager.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';

import { FootprintManager_storage_categories_gridComponent } from './FootprintManager.storage_categories_grid.component';
import { FootprintManager_storage_category_rules_gridComponent } from './FootprintManager.storage_category_rules_grid.component';
import { FootprintManager_temperature_capture_reading_points_gridComponent } from './FootprintManager.temperature_capture_reading_points_grid.component';
import { FootprintManager_temperature_capture_reading_types_gridComponent } from './FootprintManager.temperature_capture_reading_types_grid.component';

@Component({
  standalone: true,
  imports: [
    SharedModule,
    forwardRef(() => FootprintManager_storage_categories_gridComponent),
    forwardRef(() => FootprintManager_storage_category_rules_gridComponent),
    forwardRef(() => FootprintManager_temperature_capture_reading_points_gridComponent),
    forwardRef(() => FootprintManager_temperature_capture_reading_types_gridComponent),
  ],
  selector: 'FootprintManager-configurations_storage_categories_hub',
  templateUrl: './FootprintManager.configurations_storage_categories_hub.component.html'
})
export class FootprintManager_configurations_storage_categories_hubComponent extends BaseComponent implements OnInit, OnDestroy {


  @Input() showInDialog: boolean = false; 
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();  
  //#endregion Outputs
  hasToolbar: boolean = true;



  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  //#region Variables
  //#endregion
  formGroup: FormGroup = new FormGroup({
  });
  
  toolbar = {
  };

  actionbar = {
  };

 filters = {
  };


  filtersets = {
};

    rootTabGroup = new TabGroupModel();
  
    subTabGroups = {
    };
  
    onTabSelected(event: MatSelectChange) {
      event.value.activate();
    }
  
    tabs = {
      storage_categories: new TabItemModel(
        this.rootTabGroup, 
        'Storage categories', 
        false,
        ),
      storage_category_rules: new TabItemModel(
        this.rootTabGroup, 
        'Storage rules', 
        false,
        ),
      temperature_capture_reading_points: new TabItemModel(
        this.rootTabGroup, 
        'Temperature points', 
        false,
        ),
      temperature_capture_reading_types: new TabItemModel(
        this.rootTabGroup, 
        'Temperature types', 
        false,
        ),
    };
  
  
    //#region tabs inParams
    //#endregion tabs inParams
  
    //#region tabs children
      @ViewChild('$tabs_storage_categories', { read: FootprintManager_storage_categories_gridComponent }) $tabs_storage_categories: FootprintManager_storage_categories_gridComponent;
      @ViewChild('$tabs_storage_category_rules', { read: FootprintManager_storage_category_rules_gridComponent }) $tabs_storage_category_rules: FootprintManager_storage_category_rules_gridComponent;
      @ViewChild('$tabs_temperature_capture_reading_points', { read: FootprintManager_temperature_capture_reading_points_gridComponent }) $tabs_temperature_capture_reading_points: FootprintManager_temperature_capture_reading_points_gridComponent;
      @ViewChild('$tabs_temperature_capture_reading_types', { read: FootprintManager_temperature_capture_reading_types_gridComponent }) $tabs_temperature_capture_reading_types: FootprintManager_temperature_capture_reading_types_gridComponent;
    //#endregion tabs children


  get hubTitle(): string {
    const $hub = this;
    const $utils = this.$utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    return `Temperature and storage`;
  }

  get hubDescription(): string {
    const $hub = this;
    const $utils = this.$utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    return `Configuration options for temperature reading and storage.`;
  }

  constructor(
  private $utils: UtilsService,
  private $settings: SettingsValuesService,
  private $shell: FootprintManager_ShellService,
  private $datasources: FootprintManager_DatasourceService,
  private $flows: FootprintManager_FlowService,
  private $reports: FootprintManager_ReportService,
  private $localization: FootprintManager_LocalizationService,
  private $operations: FootprintManager_OperationService,
  private $logger: CleanupLoggerService,
  private $context: FootprintManager_configurations_storage_categories_hub_ComponentContextService,
  ) { 
    super();
    this.$subscribeFormControlValueChanges();
    this.hasToolbar = !isEmpty(this.toolbar);

    //#region tabs tab init
    this.rootTabGroup.tabs = [
      this.tabs.storage_categories,
      this.tabs.storage_category_rules,
      this.tabs.temperature_capture_reading_points,
      this.tabs.temperature_capture_reading_types,
    ]; 
    //#endregion tabs tab init
  }

  ngOnInit(): void {
    this.$init();
  }
  

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }



  initialized = false;

  async $init() {
    this.title = 'Storage Configurations';
    
    const $hub = this;
    const $utils = this.$utils;


    await this.on_init();

    this.initialized = true;
  }

  private $subscribeFormControlValueChanges() {
  }
  close() {
    this.$finish.emit();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = Promise.resolve(null);
    
    // children
    if (skipChildren === false) {
      this.$refreshChildren(childToSkip);
    }

    return result;
  }

  $refreshChildren(childToSkip: string) {
    //#region tabs children
    if (childToSkip !== '$tabs_storage_categories') {
      if (!isNil(this.$tabs_storage_categories) && !this.tabs.storage_categories.hidden) {
        this.$tabs_storage_categories.refresh(true, false, null);
      }
    }
    if (childToSkip !== '$tabs_storage_category_rules') {
      if (!isNil(this.$tabs_storage_category_rules) && !this.tabs.storage_category_rules.hidden) {
        this.$tabs_storage_category_rules.refresh(true, false, null);
      }
    }
    if (childToSkip !== '$tabs_temperature_capture_reading_points') {
      if (!isNil(this.$tabs_temperature_capture_reading_points) && !this.tabs.temperature_capture_reading_points.hidden) {
        this.$tabs_temperature_capture_reading_points.refresh(true, false, null);
      }
    }
    if (childToSkip !== '$tabs_temperature_capture_reading_types') {
      if (!isNil(this.$tabs_temperature_capture_reading_types) && !this.tabs.temperature_capture_reading_types.hidden) {
        this.$tabs_temperature_capture_reading_types.refresh(true, false, null);
      }
    }
    //#endregion tabs children
  }

  openImageViewer(imageSource: string) {
    this.$shell.openImageViewerDialog(imageSource);
  }

  //#region private flows
  on_init(event = null) {
    return this.on_initInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_initInternal(
    $hub: FootprintManager_configurations_storage_categories_hubComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_configurations_storage_categories_hub_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  if (await $operations.FootprintManager.Disable_Navigation_Settings_Storage_Categories.isAuthorized()) {
      
      $hub.close();
      throw new Error ('This screen currently requires authorization, please see your system admin for access.')
    
  }
  
  
  
  $hub.title = 'Temperature and storage'
  }
  //#endregion private flows
}
